import { SearchOperator } from './search-query-model';

const valuelessOperators: SearchOperator[] = ['empty', 'exists', '!exists'];

export function operatorRequiresValue(operator: SearchOperator): boolean {
  return !valuelessOperators.includes(operator);
}
